
export const getCookie = (name) => {
  const dc = document.cookie;
  const prefix = name + '=';
  let begin = dc.indexOf('; ' + prefix);
  if (begin === -1) {
    begin = dc.indexOf(prefix);
    if (begin !== 0) return null;
  } else {
    begin += 2;
  }
  let end = dc.indexOf(';', begin);
  if (end === -1) end = dc.length;
  return decodeURI(dc.substring(begin + prefix.length, end));
};

export const checkCookies = (removeCookie) => {
  const myCookie = getCookie('session_id');
  if (!myCookie) {
    console.log('session_id not exist');
    removeCookie('session_id', { path: '/' });
    removeCookie('user', { path: '/' });
    window.location.reload(false);
  }
};

export const toDate = (unix) => {
  const dateObject = new Date(parseInt(unix) * 1000);
  return dateObject.toLocaleString('en-GB');
};
